// The account-page content title: headline + the "Talk to Sleep Expert" phone
// line. Shared by every account document body so the header block stays
// byte-identical across pages.
import { Immutable } from "immer";
import React from "react";
import { jt } from "ttag";

type IProps = Immutable<{
    contentTitle: string;
    phoneDisplay: string;
    phoneHref: string;
}>;

export const AccountContentTitle = (props: IProps): React.JSX.Element => {
    // ttag's `jt` forbids a conditional/logical expression directly inside the
    // `${...}` interpolation, so compute the optional phone link first.
    const phoneLink = props.phoneDisplay ? (
        <a key="phone" href={props.phoneHref}>
            {props.phoneDisplay}
        </a>
    ) : null;
    return (
        <div className="content-title">
            <h1 className="content-title__headline">{props.contentTitle}</h1>
            <span className="content-title__info">
                {jt`Talk to Sleep Expert ${phoneLink}`}
            </span>
        </div>
    );
};
